
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms_of_use",
      function () {
        return require("private-next-pages/terms_of_use/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms_of_use"])
      });
    }
  